import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface MuliPeriodAllocationRequest {
  glPeriodId: number;
  amount: number;
}

interface MultiPeriodAllocationResponse {
  poId: string;
  success: boolean;
}

const useMultiPeriodAllocationUpdateApi = (poId: string) => {
  const call = useCallback(
    async (data?: MuliPeriodAllocationRequest[]) => {
      try {
        const res = await axiosInstance.put<MultiPeriodAllocationResponse>(
          api.getMultiPeriodAllocation(poId),
          {
            periodAllocations: data,
          }
        );
        const success: boolean = res.status === 200 || res.status === 204;
        if (success) {
          return {
            poId,
            success,
          };
        }
        return res.data;
      } catch (error) {
        throw new Error(error);
      }
    },
    [poId]
  );

  const { execute, value, isLoading } = useAsync(call, false);

  return {
    updateMultiPeriodAllocation: execute,
    multiPeriodAllocationList: value,
    isMultiPeriodLoading: isLoading,
  };
};

export default useMultiPeriodAllocationUpdateApi;
